import styled from "styled-components";
import { Link } from "react-router-dom";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const BreadCrumbDiv = styled.div`
  display: ${(props) => (props.hideBreadCrumbNavigation ? "none" : "flex")};
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  padding: 29px 0;
  margin-bottom: 20px;
  ${breakpoints.smDown} {
    padding: 20px 0;
  }
  border-bottom: 1.5px solid ${colors.silver};
`;

const CommonBackButtonStyles = `
  font-family: ${fonts.fontConceptRegular};
  font-weight: ${(props) => (props.bold ? "bold" : "normal")};
  font-size: 16px;
  line-height: 22px;
  color: ${colors.black};
  padding: 0 10px 0 0;
`;

export const BackButtonText = styled.span`
  ${CommonBackButtonStyles}
`;

export const BackButtonLink = styled(Link)`
  ${CommonBackButtonStyles}
`;
